import { render } from "./SessionsItem.vue?vue&type=template&id=60510397&ts=true"
import script from "./SessionsItem.vue?vue&type=script&lang=ts"
export * from "./SessionsItem.vue?vue&type=script&lang=ts"

import "./SessionsItem.vue?vue&type=style&index=0&id=60510397&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__